module.exports = __webpack_public_path__ + "static/media/Questlogoheader_white.dc9ef3f4.png";